<script setup>
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  remainingSeconds: {
    type: Number,
    default: 10
  }
});

const emit = defineEmits(['stay-active', 'logout', 'update:open']);

// Create computed property to handle v-model correctly
const dialogOpen = computed({
  get: () => props.open,
  set: (value) => emit('update:open', value)
});

const handleStayActive = () => {
  emit('stay-active');
};

const handleLogout = () => {
  emit('logout');
};
</script>

<template>
  <v-dialog v-model="dialogOpen" persistent max-width="400px">
    <v-card>
      <v-card-title class="text-h5 bg-warning text-white">
        <v-icon start icon="mdi-alert-circle" class="mr-2"></v-icon>
        Aviso de inatividade
      </v-card-title>
      
      <v-card-text class="pt-4">
        <p class="text-body-1 mb-4">
          Você está inativo há mais de 30 minutos.
        </p>
        <p class="text-body-1 mb-4">
          Sua sessão será encerrada em {{ remainingSeconds }} segundos devido à inatividade.
        </p>
        <p class="text-body-1 mb-2">
          Deseja continuar conectado?
        </p>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey-darken-1" variant="text" @click="handleLogout">
          Sair
        </v-btn>
        <v-btn color="primary" @click="handleStayActive">
          Continuar conectado
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
